function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.52788,
  cy: 9.52788,
  r: 9.47212,
  transform: "rotate(180 9.52788 9.52788)",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.64485 11.0263L9.76276 14.1442C9.90654 14.2931 9.9861 14.4925 9.98431 14.6994C9.98251 14.9064 9.89949 15.1044 9.75314 15.2507C9.60679 15.3971 9.40882 15.4801 9.20185 15.4819C8.99489 15.4837 8.7955 15.4041 8.64663 15.2604L4.18131 10.795C4.10776 10.7219 4.04939 10.635 4.00956 10.5392C3.96972 10.4434 3.94922 10.3407 3.94922 10.237C3.94922 10.1332 3.96972 10.0305 4.00956 9.93477C4.04939 9.839 4.10776 9.75204 4.18131 9.67891L8.64663 5.21359C8.79617 5.07336 8.9944 4.99681 9.19938 5.00014C9.40436 5.00347 9.6 5.08642 9.74491 5.23143C9.88982 5.37644 9.97263 5.57214 9.97581 5.77712C9.979 5.9821 9.90231 6.18028 9.76197 6.32973L6.64406 9.44763L14.2107 9.44763C14.4201 9.44763 14.6208 9.53079 14.7689 9.67882C14.9169 9.82686 15.0001 10.0276 15.0001 10.237C15.0001 10.4463 14.9169 10.6471 14.7689 10.7951C14.6208 10.9432 14.4201 11.0263 14.2107 11.0263L6.64485 11.0263Z",
  fill: "#030710"
});
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.8ecfad2aed29e10aac1996bf1ce9c73a.svg";
export { ForwardRef as ReactComponent };